import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { createSelector } from "@reduxjs/toolkit";
export interface DeviceState {
  devices: Devices;
}

export type Device = {
  eui: string;
  lat: number;
  lng: number;
  name: string;
  group_id: string;
  hw_vn: string;
  sw_vn: string;
  images: string[];
  status: Status;
  configuration: DeviceConfiguration;
  id: string;
  gateways: GatewayInfo;
  settings: DeviceSettings;
};

export type Devices = Device[];

export type GatewayInfo = {
  [key: string]: Gateway;
};

export type Gateway = {
  lat: number;
  lng: number;
  name: string;
  last_contact_ts: Date;
};

type Status = {
  claimed: boolean;
  last_message_ts: Date;
  online: boolean;
};

export type DeviceConfiguration = {
  [key: string]: PhenomenaConfiguration[];
};

export type PhenomenaConfiguration = {
  ident: number;
  description: string;
  unit: string;
  type: string;
  sensor_sn: string;
  elemID: string;
};

export type DeviceSettings = {
  offline_notification_active: boolean;
  offline_notification_recipient_id: string;
};

const initialState: DeviceState = {
  devices: [],
};

export const deviceSlice = createSlice({
  name: "device",
  initialState,
  reducers: {
    addDevices: (state: any, action: PayloadAction<Devices>) => {
      state.devices = action.payload;
    },
    addDevice: (state: any, action: PayloadAction<Device>) => {
      state.devices[action.payload.id] = action.payload;
    },
    //=============== Logout Action ===============
    clearDevices: (state: any) => {
      state.devices = [];
    },
    deleteDevice: (state: any, action: PayloadAction<string>) => {
      delete state.devices[action.payload];
    },
  },
});

export const selectDevices = (state: RootState) => state.devices;
const selectDevicesState = (state: RootState) => state.devices.devices;

export const selectDevice = (state: RootState, id: string) => {
  if (!id) return undefined;
  const device = state.devices.devices.find((device) => device.id === id);
  return device ? device : undefined;
};
export const selectDeviceByEUI = (state: RootState, deviceEUI: string) => {
  if (!deviceEUI) return undefined;
  const device = state.devices.devices.find((device) => device.eui === deviceEUI);
  return device ? device : undefined;
};
export const selectDevicesByGroupId = (state: RootState, groupId?: string) => {
  if (!groupId) return [];
  return state.devices.devices.filter((device) => device.group_id === groupId);
};
export const makeSelectDevicesByGroupId = () =>
  createSelector(
    [selectDevicesState, (_: RootState, groupId?: string) => groupId],
    (devices, groupId) => {
      if (!groupId) return [];
      return devices.filter((device) => device.group_id === groupId);
    }
  );

export const { addDevices, clearDevices, addDevice, deleteDevice } = deviceSlice.actions;

export default deviceSlice.reducer;

//I heada back to store.tsx that is found in the folder app
